/**
 * Errors thrown by the pure functions in this package. The API maps them to
 * HTTP errors; the frontends map them to form messages.
 */
export type SharedErrorCode =
  'INVALID_MONEY' | 'INVALID_PHONE' | 'INVALID_SETTLEMENT_INPUT' | 'INVALID_QUOTE_INPUT';

export class SharedError extends Error {
  readonly code: SharedErrorCode;

  constructor(code: SharedErrorCode, message: string) {
    super(message);
    this.name = 'SharedError';
    this.code = code;
  }
}
